// extracted by mini-css-extract-plugin
module.exports = {"root":"HeaderSection-module--root--1bq_O","container":"HeaderSection-module--container--_cmpq","title":"HeaderSection-module--title--1r_CI"};